import { HelmetDexteel } from "@dexteel/mesf-core";
import { PassChangeReasonsManager } from "./components/PassChangeReasonsManager";

export const PassChangeReasonsPage = () => {
	return (
		<>
			<HelmetDexteel title="Pass Change Reasons" />
			<PassChangeReasonsManager />
		</>
	);
};
